import { ItemText } from './styles'

interface ListItemTextProps {
  text: string
}

export const ListItemText = ({ text }: ListItemTextProps) => {
  return <ItemText>{text}</ItemText>
}
